// removed by extract-text-webpack-plugin
module.exports = {"container":"src-ui----Header-module---container---1nDfA","header":"src-ui----Header-module---header---XHgeT","menuVisible":"src-ui----Header-module---menuVisible---3B8wo","headerLogo":"src-ui----Header-module---headerLogo---2ULm6","headerMenuButton":"src-ui----Header-module---headerMenuButton---11e6x","active":"src-ui----Header-module---active---QVVJ7"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/Header.module.scss
// module id = 563
// module chunks = 168707334958949